import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=54998329&"
import script from "./Lightbox.vue?vue&type=script&lang=js&"
export * from "./Lightbox.vue?vue&type=script&lang=js&"
import style0 from "./lightbox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports